export * from './company-ranking.interface';
export * from './feedback-by-company.interface';
export * from './feedback-challenge.interface';
export * from './feedback.interface';
export * from './score.interface';
export * from './report.interface';